/**
 * Trigger: tr_debtors_soft_delete
 * Purpose: Update account balances and soft delete payments when a debtor is soft deleted
 * Table: debtors
 * Event: UPDATE OF is_deleted
 */
export const TR_DEBTORS_SOFT_DELETE = `
CREATE TRIGGER tr_debtors_soft_delete
UPDATE OF is_deleted ON debtors
BEGIN
  UPDATE account_balances
  SET debtors_amount = CASE
    WHEN new.is_deleted = 0 THEN debtors_amount + old.amount
    ELSE debtors_amount - old.amount
  END
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id
    AND new.is_deleted <> old.is_deleted;

  UPDATE account_daily_balances
  SET debtors_amount = CASE
    WHEN new.is_deleted = 0 THEN debtors_amount + old.amount
    ELSE debtors_amount - old.amount
  END
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.debtor_date
    AND new.is_deleted <> old.is_deleted;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_id
    AND NOT EXISTS (
    SELECT _id FROM account_daily_balances
    WHERE account_daily_balances.account_id = account_activity_dates.account_id
      AND account_daily_balances.balance_date = account_activity_dates.activity_date
  );

  UPDATE debtor_payments
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM debtor_payments),
      updated_at = strftime('%s', 'now')
  WHERE debtor_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;
END;
`;
